export default __webpack_public_path__ + "static/media/Files_Encrypted.60811101.png";